import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { OLD_PRICE, PRICE } from '../data/judo';
const recap = ['6 tomów', '5 bonusów', '12 zajęć minuta po minucie', 'Grupy 4–15 lat'];
const reassurances = ['Natychmiastowy dostęp do pobrania', 'PDF do druku', '7 dni gwarancji satysfakcji'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-102" data-mp="15fq9udt8tk99">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-103" data-mp="1jasb2nn5alfq" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-104" data-mp="1t2ojariy3rxo">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-105" data-mp="1t510h2gvpy9o">
          Twoje treningi judo mogą być <em className="text-red-700" data-id="element-106" data-mp="22339a46utv7i">gotowe już dziś.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-107" data-mp="2219zig0y2uva">
          Zamiast szukać pomysłów po internecie, wymyślać każde ćwiczenie od nowa i spędzać niedzielne
          wieczory nad konspektem, masz uporządkowany pakiet na cały sezon judo. Więcej czasu na to, co
          naprawdę ważne:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-108" data-mp="x38x9n1sxm27">
          Twoi zawodnicy. Twoja mata. Twoje życie poza dojo.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-109" data-mp="164glfcalt6ik">
          {recap.map(item => <li key={item} data-id="element-110" data-mp="1b2ruhkt2rczq">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-2xl leading-none text-slate-900/50" data-id="element-111" data-mp="1b1guzx6nwref">
          <span className="sr-only" data-id="element-112" data-mp="1fv1tdqc63ne5">Cena regularna: </span>
          <s data-id="element-113" data-mp="1ktmiatlyykna">{OLD_PRICE}</s>
        </p>
        <p className="mt-3 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-114" data-mp="1ksl6gmx4pu4i">
          <span className="sr-only" data-id="element-115" data-mp="1puaj27002fup">Cena teraz: </span>
          {PRICE}
        </p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-116" data-mp="1tuko9hfyx28i">Jednorazowa płatność – bez subskrypcji.</p>

        <div className="mt-8 flex justify-center" data-id="element-117" data-mp="3qv70uc83wa6t">
          <CtaButton className="w-full sm:w-auto" data-id="element-118" data-mp="3lvudzrh8j348" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-119" data-mp="3lthngpxevkfk">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-120" data-mp="3uwiuqty0jhkt">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-121" data-mp="3uuz9sq1ewicp" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}